import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as o } from "../../../../IconBase-CxZyIWw2.js";
const a = i((e, t) => /* @__PURE__ */ s.jsx(
  o,
  {
    ref: t,
    ...e,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: [
          /* @__PURE__ */ s.jsxs(
            "mask",
            {
              id: "mask0_2974_3584",
              width: 17,
              height: 16,
              x: 0,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: [
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M15.41 9.13c-.26-.33-.46-.59-.46-1.09 0-.46.1-.55.33-.75.45-.38.92-.89.62-2.1-.35-1.44-1.38-1.53-2-1.59-.48-.04-.74-.08-1-.36-.27-.3-.26-.48-.25-.84.03-.51.07-1.37-1.16-2C10.22-.25 9.5.35 9.03.75c-.34.29-.53.44-.92.44-.36 0-.55-.16-.88-.47C6.78.3 6.02-.41 4.68.31c-1.26.67-1.22 1.57-1.19 2.1.02.37.02.49-.22.7-.31.27-.57.27-.95.28-.54 0-1.43.01-1.96 1.16-.52 1.13 0 1.87.35 2.36.23.33.42.58.42.99 0 .35-.16.56-.45.91-.41.5-1.04 1.26-.42 2.52s1.52 1.25 2.06 1.25c.36-.01.5 0 .68.17.2.19.24.43.28.88.06.62.15 1.56 1.26 2.07 1.13.52 1.86-.02 2.34-.37.36-.26.64-.47 1.13-.47.45 0 .62.17.91.44.3.29.72.7 1.46.7.22 0 .47-.04.75-.13 1.34-.42 1.39-1.44 1.41-2.05.02-.5.05-.72.36-.95.38-.27.66-.27 1.01-.27.56 0 1.4 0 1.93-1.32.43-1.06-.09-1.71-.43-2.15m-1.18.93c.31.39.32.42.22.67-.15.37-.15.37-.55.37-.44 0-1.11 0-1.88.56-.91.66-.95 1.52-.98 2.09s-.04.59-.37.69c-.37.11-.4.08-.72-.23-.35-.34-.89-.86-1.95-.86-.98 0-1.58.44-2.02.76-.44.33-.51.36-.82.22-.3-.14-.34-.26-.39-.85-.05-.53-.12-1.25-.76-1.84-.63-.58-1.28-.58-1.71-.56-.44 0-.49.01-.69-.41-.19-.4-.13-.48.23-.91.33-.4.79-.96.79-1.86 0-.89-.4-1.45-.7-1.86-.31-.44-.36-.52-.21-.86.13-.29.14-.29.61-.3.48-.01 1.2-.01 1.92-.64.79-.69.76-1.45.73-1.91-.02-.42-.02-.48.4-.71.4-.21.42-.19.83.19.37.35.93.87 1.9.87.95 0 1.51-.47 1.89-.78.4-.33.43-.36.82-.17.37.19.37.2.35.58-.02.46-.06 1.16.63 1.93.67.73 1.45.8 1.98.85.56.05.58.05.68.45.1.41.09.42-.13.6-.33.28-.88.74-.88 1.91 0 1.01.47 1.61.78 2.01"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M8 4.43c-1.97 0-3.57 1.6-3.57 3.57s1.6 3.57 3.57 3.57 3.57-1.6 3.57-3.57S9.97 4.43 8 4.43m0 5.64c-1.14 0-2.07-.93-2.07-2.07S6.86 5.93 8 5.93s2.07.93 2.07 2.07-.93 2.07-2.07 2.07"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3584)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
a.displayName = "AgencySettingsIcon";
export {
  a as AgencySettingsIcon,
  a as default
};
//# sourceMappingURL=index.js.map
